<template>
  <div>
    <div v-if="!studentActions.length" class="no-actions-message">There are no student actions to show.</div>
    <div v-if="studentActions.length">
      <b-input-group class="filter-group">
        <b-input-group-prepend is-text>
          <font-awesome-icon icon="search" />
        </b-input-group-prepend>
        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
        <b-input-group-append>
          <b-button @click="filter = null">Clear</b-button>
        </b-input-group-append>
      </b-input-group>

      <b-table striped
              :items="studentActions"
              :fields="fields"
              :per-page="perPage"
              :current-page="currentPage"
              :filter="filter"
              @filtered="onFiltered"
              small>
        <template slot="group" slot-scope="data">
          {{ data.item.studentActionGroup.name }}
        </template>
      </b-table>
      <b-pagination :total-rows="totalRows" v-model="currentPage" :per-page="perPage" align="right" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fields: [{ key: "group" }, { key: "name" }],
      currentPage: 1,
      perPage: 20,
      filter: null,
      totalRows: 0
    };
  },

  props: {
    studentActions: {
      type: Array,
      required: true
    }
  },

  watch: {
    studentActions: function() {
      this.totalRows = this.studentActions.length;
    }
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    }
  }
};
</script>

<style scoped>
.widget-body {
  font-size: 13px;
}

.filter-group {
  margin: 10px 0 15px 0;
  max-width: 600px;
}
</style>
